/**
 * @generated SignedSource<<8746542e87030a02479cb8bb6bc6a5b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FollowButton_viewer$data = {
  readonly user?: {
    readonly favorites: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "FollowButton_viewer";
};
export type FollowButton_viewer$key = {
  readonly " $data"?: FollowButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FollowButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "followSearchUriRef"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasUserId"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowButton_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 1
                },
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "pages.0",
                      "variableName": "followSearchUriRef"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "pages"
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "SEARCH"
                  ]
                }
              ],
              "concreteType": "favoritesConnection",
              "kind": "LinkedField",
              "name": "favorites",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "favoritesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Favorite",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "serviceId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0118e03b8dbe49e3b63b19ee3f230c4b";

export default node;
